import React, { Component } from "react";

import { Route, Switch, withRouter, Redirect } from "react-router-dom";
import "./App.css";
import rawAxios from "axios";
import { connect } from "react-redux";
import asyncComponent from "./hoc/asyncComponent/asyncComponent";

import Layout from "./components/Layout/Layout";
import OverviewPage from "./components/OverviewPage/OverviewPage";
import DevicesPage from "./components/DevicesPage/DevicesPage";
import AdvancedConfigurationsPage from "./components/AdvancedConfigurationsPage/AdvancedConfigurationsPage";
import NetworkPage from "./components/NetworkPage/NetworkPage";
import PropertyManager from "./containers/PropertyManager/PropertyManager";
import * as actions from "./store/actions/index";
import Blocked from "./containers/Blocked/Blocked";
import Health from "./containers/Health/Health";
import queryString from "query-string";
import Auth from "./containers/Auth/Auth";
import SwitchAccountsForm from "./components/Layout/SwitchAccountsForm/SwitchAccountsForm";
import Modal from "./components/UI/Modal/Modal";
import Toast from "./components/UI/Toast/Toast";
import MultiRouterAccount from "./containers/MultiRouterAccount/MultiRouterAccount";
import ThreadNetworkOverviewPage from "./components/ThreadNetworkOverviewPage/ThreadNetworkOverviewPage";
import AuthError from "./components/UI/AuthError/AuthError";

const asyncAuth = asyncComponent(() => {
  return Auth;
});

// Apply pending startApp session data BEFORE React renders.
// This runs synchronously at module load time so the routing logic in render()
// sees the correct session state on the very first frame — no flash of the wrong page.
// Pending data older than 30 seconds is discarded as stale (user likely canceled and refreshed later).
(function applyPendingStartApp() {
  const pendingStartApp = sessionStorage.getItem('pendingStartApp');
  if (pendingStartApp && pendingStartApp !== 'null') {
    try {
      const pendingData = JSON.parse(pendingStartApp);
      const age = Date.now() - (pendingData.timestamp || 0);
      // Only apply if the pending data is fresh (less than 30 seconds old)
      if (age < 30000) {
        sessionStorage.setItem('authCode', pendingData.authCode);
        sessionStorage.setItem('divID', pendingData.divID);
        sessionStorage.setItem('mac', pendingData.mac);
        sessionStorage.setItem('vendorModel', pendingData.vendorModel);
        sessionStorage.setItem('featureFlags', pendingData.featureFlags);
        sessionStorage.setItem('type', pendingData.type);
        sessionStorage.setItem('sessionToken', pendingData.sessionToken);
        sessionStorage.setItem('masterAcct', pendingData.masterAcct);
        sessionStorage.setItem('accountNumber', pendingData.accountNumber);
        sessionStorage.setItem('subclass', pendingData.subclass);
        if (pendingData.pspPage !== null && pendingData.pspPage !== undefined) {
          sessionStorage.setItem('pspPage', pendingData.pspPage);
        }
        if (pendingData.tenantAddressLine1) {
          sessionStorage.setItem('tenantAddressLine1', pendingData.tenantAddressLine1);
        }
        if (pendingData.tenantAddressLine2) {
          sessionStorage.setItem('tenantAddressLine2', pendingData.tenantAddressLine2);
        }
      }
    } catch (e) {
      console.error('Failed to apply pending startApp data', e);
    }
    sessionStorage.removeItem('pendingStartApp');
  }
})();

class App extends Component {
  componentDidMount() {
    this.init();
  }

  async init() {
    // console.log("WORKING");
    await caches.keys().then((keyList) => Promise.all(keyList.map((key) => caches.delete(key))));

    const valProm = Promise.resolve(queryString.parse(this.props.location.search));
    const getValues = () => {
      return valProm;
    };
    const values = await getValues();
    // console.log("VALUES", values);
    let userId = sessionStorage.getItem("userId");
    let accountNumber = sessionStorage.getItem("accountNumber");
    let mac = sessionStorage.getItem("mac");
    let vendorModel = sessionStorage.getItem("vendorModel");
    let type = sessionStorage.getItem("type");
    let sessionToken = sessionStorage.getItem("sessionToken");
    let winServerUrl = sessionStorage.getItem("winServerUrl");
    let esso = sessionStorage.getItem("esso");
    let authCode = sessionStorage.getItem("authCode");
    let hosted = sessionStorage.getItem("hosted");
    let techMobile = sessionStorage.getItem("techMobile");
    let handleTopology = sessionStorage.getItem("handleTopology");
    let featureFlags = sessionStorage.getItem("featureFlags");
    let masterAcct = sessionStorage.getItem("masterAcct");
    let multi = sessionStorage.getItem("multi");
    let multiMac = sessionStorage.getItem("multiMac");
    let testObj = sessionStorage.getItem("testObj");
    let groupEnabled = sessionStorage.getItem("groupEnabled");
    let adidEnabled = sessionStorage.getItem("adidEnabled");
    let specReadOn = sessionStorage.getItem("specReadOn");

    var historyState = window.history.state || {};
    var reloadCount = historyState.reloadCount || 0;
    if (performance.navigation.type === 1) {
      // Reload Browser logic
      historyState.reloadCount = ++reloadCount;
      window.history.replaceState(historyState, null, document.URL);
      console.info(
        "[" + new Date() + "]",
        "[INFO-UI]",
        "[ user= " + sessionStorage.getItem("userId") + "]",
        "[ mac= " + sessionStorage.getItem("mac") + "]",
        "[ message= user refreshed screen " + historyState.reloadCount + " times]"
      );
    } else if (reloadCount) {
      delete historyState.reloadCount;
      reloadCount = 0;
      window.history.replaceState(historyState, null, document.URL);
    }
    if (reloadCount >= 6) {
      // Now, do whatever you want...
    }
    if (
      (!winServerUrl || (winServerUrl && winServerUrl === "null")) &&
      (!esso || (esso && esso === "null")) &&
      (!authCode || (authCode && authCode === "null")) &&
      (!hosted || (hosted && hosted === "null"))
    ) {
      if (values.AUTHCODE) {
        sessionStorage.setItem("authCode", values.AUTHCODE);
      } else {
        sessionStorage.setItem("authCode", null);
      }
      if (values.WINSERVERURL) {
        sessionStorage.setItem("winServerUrl", values.WINSERVERURL);
      } else {
        sessionStorage.setItem("winServerUrl", null);
      }
      if (values.ESSO) {
        if(!values.ESSO.includes("&target=")){
          sessionStorage.setItem("esso", values.ESSO+"&target=");
        }else{
          sessionStorage.setItem("esso", values.ESSO);
        }

      } else {
        sessionStorage.setItem(null);
      }
      if (values.HOSTED) {
        console.log("is HOSTED???", values.HOSTED, values["HOSTED"]);
        sessionStorage.setItem("hosted", values.HOSTED === "true" || values.HOSTED === true ? true : false);
      } else {
        sessionStorage.setItem("hosted", null);
      }
    }
    if (!groupEnabled || (groupEnabled && groupEnabled === "null")) {
      if (values.GROUPENABLED) {
        sessionStorage.setItem("groupEnabled", values.GROUPENABLED);
      } else {
        sessionStorage.setItem("groupEnabled", null);
      }
    }
    if (!adidEnabled || (adidEnabled && adidEnabled === "null")) {
      if (values.ADIDENABLED) {
        sessionStorage.setItem("adidEnabled", values.ADIDENABLED);
      } else {
        sessionStorage.setItem("adidEnabled", null);
      }
    }
    if (!specReadOn || (specReadOn && specReadOn === "null")) {
      if (values.DWELL) {
        sessionStorage.setItem("specReadOn", values.DWELL);
      } else {
        sessionStorage.setItem("specReadOn", null);
      }
    }
    if (values.access_token) {
      localStorage.setItem("access_token", values.access_token);
    }

    if (
      !userId ||
      (userId && userId === "null" && !accountNumber) ||
      (accountNumber && accountNumber === "null" && !mac) ||
      (mac && mac === "null" && !vendorModel) ||
      (vendorModel && vendorModel === "null" && !type) ||
      (type && type === "null" && !sessionToken) ||
      (sessionToken && sessionToken === "null")
    ) {
      if (values.CUSTID) {
        sessionStorage.setItem("accountNumber", values.CUSTID);
      } else {
        sessionStorage.setItem("accountNumber", null);
      }
      if (values.DIVID) {
        sessionStorage.setItem("divID", values.DIVID);
      } else {
        sessionStorage.setItem("divID", null);
      }
      if (values.USERID) {
        sessionStorage.setItem("userId", values.USERID);
      } else {
        sessionStorage.setItem("userId", null);
      }
      if (values.ROLE) {
        sessionStorage.setItem("userRole", values.ROLE);
      } else {
        sessionStorage.setItem("userRole", null);
      }
      if (values.MAC) {
        sessionStorage.setItem("mac", values.MAC);
      } else {
        sessionStorage.setItem("mac", null);
      }
      if (values.VENDORMODEL) {
        sessionStorage.setItem("vendorModel", values.VENDORMODEL);
      } else {
        sessionStorage.setItem("vendorModel", null);
      }
      if (values.TYPE) {
        sessionStorage.setItem("type", values.TYPE);
      } else {
        sessionStorage.setItem("type", null);
      }
      if (values.sessionToken) {
        sessionStorage.setItem("sessionToken", values.sessionToken);
      } else {
        sessionStorage.setItem("sessionToken", null);
      }
    }

    const instObj = {
      withCredentials: true,
      baseURL: "https://pi.engnew-spectrum.net/tdcs/public",
      headers: {
        "Access-Control-Allow-Credentials": true,
      },
    };
    const instance = rawAxios.create(instObj);
    try {
      const responseTDCS = instance
        .get(
          "/inform?apiKey=25d0f642-a1df-4646-8b5b-8192eaa55b83&deviceId=EE5EB85D-843C-4BCB-8C83-E0550A834BD8&clientType=SCP-WIN&deviceType=ALL&appVersion=7.0&osVersion=ALL&buildType=ALL"
        )
        .then((responseTDCS) => {
          // console.log("TDCS RESPONSE", responseTDCS.data.config);
          // console.log(
          //   "TDCS RESPONSE responseTDCS.data.config.isGroupPauseEnabled",
          //   typeof responseTDCS.data.config.isGroupPauseEnabled
          // );
          sessionStorage.setItem("TDCSisGroupPauseEnabled", responseTDCS.data.config.isGroupPauseEnabled);
        });
    } catch (error) {
      console.error("THERE IS ERR GETTING TDCS", error);
    }

    if (
      (!techMobile || (techMobile && techMobile === "null")) &&
      (!handleTopology || (handleTopology && handleTopology === "null")) &&
      (!featureFlags || (featureFlags && featureFlags === "null")) &&
      (!masterAcct || (masterAcct && masterAcct === "null")) &&
      (!multi || (multi && multi === "null")) &&
      (!multiMac || (multiMac && multiMac === "null")) &&
      (!testObj || (testObj && testObj === "null"))
    ) {
      if (values.TM) {
        sessionStorage.setItem("techMobile", values.TM);
      } else {
        sessionStorage.setItem("techMobile", null);
      }
      sessionStorage.setItem("testObj", null);
      if (values.HANDLETOPOLOGY) {
        sessionStorage.setItem("handleTopology", values.HANDLETOPOLOGY);
      } else {
        sessionStorage.setItem("handleTopology", null);
      }
      if (values.FEATUREFLAGS) {
        sessionStorage.setItem("featureFlags", values.FEATUREFLAGS);
      } else {
        sessionStorage.setItem("featureFlags", null);
      }
      if (values.UR) {
        sessionStorage.setItem("ur", values.UR);
      } else {
        sessionStorage.setItem("ur", null);
      }
      if (values.USERROLES) {
        sessionStorage.setItem("userRoles", values.USERROLES);
      } else {
        sessionStorage.setItem("userRoles", null);
      }
      if (values.ISSPECTRUMREADY) {
        sessionStorage.setItem("isSpectrumReady", values.ISSPECTRUMREADY);
      } else {
        sessionStorage.setItem("isSpectrumReady", false);
      }
      if (values.MASTERACCT) {
        sessionStorage.setItem("masterAcct", values.MASTERACCT);
      } else {
        sessionStorage.setItem("masterAcct", null);
      }
      if (values.MULTI) {
        sessionStorage.setItem("multi", values.MULTI);
      } else {
        sessionStorage.setItem("multi", false);
      }
      if (values.MULTIMAC) {
        // console.log("values.MULTIMAC", values.MULTIMAC);
        sessionStorage.setItem("multiMac", values.MULTIMAC);
      } else {
        sessionStorage.setItem("multiMac", false);
      }
      if (values.SUBCLASS) {
        sessionStorage.setItem("subclass", values.SUBCLASS);
      } else {
        sessionStorage.setItem("subclass", null);
      }
    }
    let authC = values && values.AUTHCODE ? values.AUTHCODE : null;
    let winSU = values && values.WINSERVERURL ? values.WINSERVERURL : null;
    if (hosted || values.HOSTED === "true" || values.HOSTED === true) {
      if (
        !sessionStorage.getItem("sessionToken") ||
        (sessionStorage.getItem("sessionToken") && sessionStorage.getItem("sessionToken") === "null")
      ) {
        this.props.onTryAutoSignup(authC, winSU);
      } else {
        this.props.onTryAutoSignup(null, null);
      }
    } else {
      console.log("not hosted", authC);
      if (authC) {
        this.props.onTryAutoSignup(authC, winSU);
      } else {
        this.props.onTryAutoSignup(null, null);
      }
    }

    // const testingSpeedCheckValue = sessionStorage.getItem(
    //   "enableSpeedCheckTimeoutTestingValue"
    // ) || null;
    // if (testingSpeedCheckValue == null) {
    //   sessionStorage.setItem("enableSpeedCheckTimeoutTestingValue", false);
    // }
  }

  render() {
    let routes;
    let healthCheck = (
      <Switch>
        <Route path="/health-check" component={Health} />
      </Switch>
    );
    let authRoute = (
      <Switch>
        <Route path="/auth" component={asyncAuth} />
      </Switch>
    );
    let blockedRoute = (
      <Switch>
        <Route to="/blocked" component={Blocked} />
      </Switch>
    );
    let equipmentRoute = (
      <Switch>
        <Route to="/equipment" component={SwitchAccountsForm} />
      </Switch>
    );
    let pspRoute = (
      <Switch>
        <Route to="/psp" exact path="/psp" component={PropertyManager} />
        <Route path="*" render={() => <Redirect to="/psp" />} />
      </Switch>
    );

    let multiRoute = (
      <Switch>
        <Route to="/abw" exact path="/abw" component={MultiRouterAccount} />
        <Route path="*" render={() => <Redirect to="/abw" />} />
      </Switch>
    );

    if (!sessionStorage.getItem("sessionToken") || sessionStorage.getItem("sessionToken") === "null") {
      // KEEP THIS
      return <Auth />;
    } else if (sessionStorage.getItem("accountNumber") === "null") {
      return (
        <div>
          <Modal show={true}>{equipmentRoute}</Modal>
        </div>
      );
    } else if (
      (localStorage.getItem("access_token") && localStorage.getItem("access_token").length >= 100) ||
      (sessionStorage.getItem("token") && sessionStorage.getItem("token").length >= 100)
    ) {
      const { type } = this.props.selectedEquipment;
      if (type === "router") {
        routes = (
          <Switch>
            <Route path="/overview" component={OverviewPage} />
            <Route path="/devices" component={DevicesPage} />
            <Route path="*" render={() => <Redirect to="/overview" />} />
          </Switch>
        );
      } else if (type === "pod") {
        routes = (
          <Switch>
            <Route path="/overview" component={OverviewPage} />
            <Route path="/devices" component={DevicesPage} />
            <Route path="*" render={() => <Redirect to="/overview" />} />
          </Switch>
        );
      } else {
        routes = (
          <Switch>
            <Route path="/overview" component={OverviewPage} />
            <Route path="/devices" component={DevicesPage} />
            <Route path="/advancedconfigurations" component={AdvancedConfigurationsPage} />
            <Route path="/network" component={NetworkPage} />
            <Route path="/threadnetworkoverview" component={ThreadNetworkOverviewPage} />
            <Route path="*" render={() => <Redirect to="/overview" />} />
          </Switch>
        );
      }

      if (
        sessionStorage.getItem("sessionToken") &&
        (!sessionStorage.getItem("mac") || sessionStorage.getItem("mac") === "null") &&
        sessionStorage.getItem("masterAcct") &&
        sessionStorage.getItem("masterAcct").length &&
        sessionStorage.getItem("masterAcct").length >= 9
      ) {
        // KEEP THIS
        return (
          <div>
            {pspRoute}
            {/* <Toast /> */}
            <AuthError />
          </div>
        );
      } else if (
        sessionStorage.getItem("sessionToken") &&
        (!sessionStorage.getItem("mac") || sessionStorage.getItem("mac") === "null") &&
        sessionStorage.getItem("multi") &&
        sessionStorage.getItem("multi") !== "null" &&
        (!sessionStorage.getItem("multiMac") || sessionStorage.getItem("multiMac") === "null")
      ) {
        // (
        //   sessionStorage.getItem("sessionToken") &&
        //   (!sessionStorage.getItem("mac") ||
        //     sessionStorage.getItem("mac") === "null") &&
        //   (!sessionStorage.getItem("multiMac") ||
        //     sessionStorage.getItem("multiMac") === "null" ||
        //     sessionStorage.getItem("multiMac") === "false") &&
        //   sessionStorage.getItem("multi")
        // )
        // console.log('MULTTTTT', sessionStorage.getItem('multiMac'))
        // KEEP THIS
        return (
          <div>
            {multiRoute}
            {/* <Toast /> */}
            <AuthError />
          </div>
        );
      } else if (
        sessionStorage.getItem("sessionToken") &&
        sessionStorage.getItem("mac") &&
        sessionStorage.getItem("mac").length >= 8 &&
        sessionStorage.getItem("mac").length <= 18
      ) {
        // KEEP THIS
        return (
          <div>
            <Layout routes={routes} />
            {/* <Toast /> */}
            <AuthError />
          </div>
        );
      }
    } else {
      return (
        <div>
          {authRoute}
          {/* <Toast /> */}
          <AuthError />
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    selectedEquipment: state.equipment.selectedEquipment,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAutoSignup: (authC, winSU) => {
      dispatch(actions.authCheckState(authC, winSU));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
